const getSchemaURI = (name, version) => `iglu:com.foodsby/${name}/jsonschema/${version}`

export const addGlobalEntities = async entities => {
  // Replace the context if exists
  // TODO we might want to figure out a way to avoid replacing if the data did not change
  if (window.snowplow) {
    await window.snowplow('removeGlobalContexts', entities)
    await window.snowplow('addGlobalContexts', entities)
  }
}

export const pushSnowplow = (schema, localEntities) =>
  window.snowplow && window.snowplow('trackSelfDescribingEvent', schema, localEntities)

export const toSignupProcessSchema = (stepType, stepName, stepValue, failureReason) => {
  return {
    data: {
      failure_reason: failureReason,
      step_name: stepName,
      step_type: stepType,
      step_value: stepValue,
    },
    schema: getSchemaURI('sign_up_process', '1-0-0'),
  }
}

export const toOrderProcessSchema = (stepType, stepName, stepValue, failureReason) => {
  return {
    data: {
      failure_reason: failureReason,
      step_name: stepName,
      step_type: stepType,
      step_value: stepValue,
    },
    schema: getSchemaURI('order_process', '1-0-0'),
  }
}

export const toUserSchema = (id, username) => {
  return {
    data: {
      id,
      username,
    },
    schema: getSchemaURI('user', '1-0-0'),
  }
}

export const toLocationSchema = id => {
  return {
    data: {
      id,
    },
    schema: getSchemaURI('location', '1-0-0'),
  }
}

export const toOrderSchema = (
  id,
  totalInCents,
  isLate,
  isDelivered,
  isCanceled,
  programId,
  couponId,
  giftId,
) => {
  return {
    data: {
      coupon_id: couponId,
      gift_id: giftId,
      id,
      is_canceled: isCanceled,
      is_delivered: isDelivered,
      is_late: isLate,
      program_id: programId,
      total_in_cents: totalInCents,
    },
    schema: getSchemaURI('order', '1-0-0'),
  }
}

export const toDeliverySchema = (
  deliveryDropoffId,
  verticalListPos,
  horizontalListPos,
  status,
  storeId,
  cutoffTime,
  dropoffTime,
  menuId,
  date,
) => {
  return {
    data: {
      cutoff_time: cutoffTime,
      date,
      delivery_dropoff_id: deliveryDropoffId,
      dropoff_time: dropoffTime,
      horizontal_list_pos: horizontalListPos,
      menu_id: menuId,
      status,
      store_id: storeId,
      vertical_list_pos: verticalListPos,
    },
    schema: getSchemaURI('delivery', '1-0-0'),
  }
}

export const toDeliveryEntities = deliveries =>
  deliveries &&
  deliveries.map(delivery =>
    toDeliverySchema(
      delivery.deliveryDropoffId,
      undefined, // TODO Add these vertical/horizontal positions of a delivery card
      undefined,
      delivery.isPastCutoff ? 'isPastCutoff' : 'isBeforeCutoff',
      delivery.storeId,
      delivery.cutoff,
      delivery.dropoff,
      delivery.menuId,
      delivery.date,
    ),
  )

export const toOrderEntities = orders =>
  orders &&
  orders.map(order =>
    toOrderSchema(
      order.orderId,
      order.orderTotal,
      order.orderState === 'LATE',
      order.isDelivered,
      order.orderState === 'CANCELED',
    ),
  )
